// AssoBureau.jsx — Page /dashboard/bureau (gestion du bureau de l'asso)
import BureauManager from '../components/BureauManager';
import TransferPresidencyCard from '../components/TransferPresidencyCard';
import BureauHistorique from '../components/BureauHistorique';
import { usePermissions } from '@/lib/usePermissions';
import { Lock } from 'lucide-react';

export default function AssoBureau() {
  const { can, loading } = usePermissions();

  if (loading) return <div className="p-8" />;

  if (!can('bureau', 'list')) {
    return (
      <div className="p-8 max-w-2xl mx-auto" data-testid="bureau-denied">
        <div className="card text-center py-12">
          <Lock className="w-8 h-8 mx-auto mb-3 text-[#CBD5E1]" />
          <h3 className="font-display text-lg font-bold text-[#0F172A] mb-2">Accès refusé</h3>
          <p className="text-sm text-[#475569]">Cette page est réservée aux membres du bureau.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-8 lg:p-12 max-w-5xl mx-auto" data-testid="asso-bureau-page">
      <div className="mb-8 slide-up">
        <div className="label-uppercase mb-2" style={{ color: 'var(--theme-primary)' }}>Bureau</div>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#0F172A] mb-3">
          Composition du bureau
        </h1>
        <p className="text-sm text-[#475569] max-w-2xl">
          Le bureau de votre association. Seul le président peut désigner les rôles : vice-président, secrétaire, trésorier.
        </p>
      </div>

      {can('bureau', 'designer') && <TransferPresidencyCard />}

      <BureauManager canDesigner={can('bureau', 'designer')} />

      <BureauHistorique />
    </div>
  );
}
